module.exports = {"component":"input","status":"prod","display-name":"Inputs","last-accessibility-review":{"date-iso-8601":"2017/09/22","commit-sha":"ad6b6c6523ee21cada11be5f7ea4d99abc530726"},"SLDS-component-path":"/components/input","url-slug":"inputs"}


//////////////////
// WEBPACK FOOTER
// ./components/input/docs.json
// module id = 81
// module chunks = 0